export default __webpack_public_path__ + "static/media/logo-ridtv.ad3f6005.svg";